import React from 'react';
import DemoStage from '../DemoStage.jsx';

/**
 * Animated walkthrough of adding a per-case requirement: the checklist starts
 * with two items, the manager requests a Training certificate from the comment
 * composer's Add → Requirement pop-up, and a third slot lands on the checklist.
 * Slots reuse the real .attach-slot classes; the type list mirrors the
 * admin-configured requirementTypes vocabulary. Placeholder data only.
 */

const STEPS = [
  {
    caption: 'The checklist mixes automatic slots with per-case requests.',
    scene: 'list', ms: 2400,
    cursor: 'add',
  },
  {
    caption: 'From the comment composer: + Add → Requirement, then Request Document.',
    scene: 'menu', ms: 2200,
    cursor: 'add', click: true,
  },
  {
    caption: 'Pick the document to request — the type list comes from your admin configuration.',
    scene: 'menu', ms: 2200,
    cursor: 'opt',
  },
  {
    caption: 'Stage it on the comment and post.',
    scene: 'menu', ms: 1200,
    cursor: 'opt', click: true,
  },
  {
    caption: 'The new slot lands on the checklist, awaiting upload — Remove takes it off again.',
    scene: 'added', ms: 3200,
  },
];

function Slot({ satisfied, label, status, pop }) {
  return (
    <div className={`attach-slot${pop ? ' kb-pop' : ''}`} data-satisfied={satisfied ? 'true' : 'false'} style={{ marginBottom: 6 }}>
      <div className="attach-slot-head" style={{ cursor: 'default' }}>
        <span className="attach-slot-icon">{satisfied ? '✓' : '!'}</span>
        <span className="attach-slot-label">{label}</span>
        <span className="attach-slot-status">{status}</span>
      </div>
    </div>
  );
}

export default function RequirementsDemo() {
  return (
    <DemoStage steps={STEPS} label="Requesting a document on a case" height={250}>
      {(step) => {
        const scene = step?.scene ?? 'list';
        const menuOpen = scene === 'menu';
        const added = scene === 'added';
        return (
          <div className="kb-mock">
            <Slot satisfied label="Consent form" status="1 uploaded" />
            <Slot label="Sign-off: Confirm corrective action" status="Awaiting sign-off" />
            {added && <Slot label="Training certificate" status="Awaiting upload" pop />}

            <div style={{ position: 'relative', marginTop: 10 }}>
              <button type="button" className="btn ghost sm" tabIndex={-1} data-kb-target="add">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                  strokeLinecap="round" strokeLinejoin="round" style={{ width: 13, height: 13 }}>
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
                Add → Requirement
              </button>
              {menuOpen && (
                <div style={{
                  position: 'absolute', top: '100%', left: 0, zIndex: 5, marginTop: 4,
                  background: 'var(--surface)', border: '1px solid var(--border)',
                  borderRadius: 8, padding: '4px 0', minWidth: 210,
                  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                }}>
                  {['Training certificate', 'Dosage chart', 'Laser log files', 'Other (specify)…'].map((label, i) => (
                    <div
                      key={label}
                      data-kb-target={i === 0 ? 'opt' : undefined}
                      style={{
                        padding: '7px 14px', fontSize: 12.5,
                        color: 'var(--text)', background: i === 0 ? 'var(--surface-2)' : 'none',
                      }}
                    >
                      {label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      }}
    </DemoStage>
  );
}
